import React, { useContext } from "react";

// AssetDownloadContext
import AssetDownloadContext from "core/AssetDownload/Context";
import {
    setAttributionIsVisible,
    setShowSpeechBubble,
    setAttributionCopied
} from "core/AssetDownload/Context/actions";

// components
import Modal from "core/Modal";
import OpeningText from "./OpeningText";
import CopyAttributionWidget from "../CopyAttributionWidget";

const AttributionModal = () => {
    const { state, dispatch } = useContext(AssetDownloadContext);

    const {
        attribution: { isCopied, isVisible }
    } = state;

    const handleModalClose = () => {
        dispatch(setAttributionIsVisible(false));
        dispatch(setAttributionCopied(false));
        if (isCopied) {
            dispatch(setShowSpeechBubble(true));
        }
    };

    return (
        <div>
            <Modal
                open={isVisible}
                handleClose={handleModalClose}
                heading="You must attribute the artist"
                headingSize="sm"
                closeOnEscape
                closeOnBackDropClick
            >
                <OpeningText />
                <CopyAttributionWidget />
            </Modal>
        </div>
    );
};

export default AttributionModal;
